/**
 * This module provides a locking mechanism to indicate whether preloading is in progress.
 */
let preloadingEnabled = false;

export const enablePreloading = () => {
	preloadingEnabled = true;
};

export const disablePreloading = () => {
	preloadingEnabled = false;
};

export const isPreloading = () => preloadingEnabled;
